import { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, getCurrentUser } from '../lib/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('sesiona_token');
    const savedUser = localStorage.getItem('sesiona_user');
    
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (e) {
        localStorage.removeItem('sesiona_token');
        localStorage.removeItem('sesiona_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    localStorage.setItem('sesiona_token', data.token);
    localStorage.setItem('sesiona_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('sesiona_token');
    localStorage.removeItem('sesiona_user');
    setUser(null);
  };

  const isAdmin = () => user?.rol === 'admin';
  const isCoach = () => user?.rol === 'coach';

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin, isCoach }}>
      {children}
    </AuthContext.Provider>
  );
};
